import React, { PropTypes } from 'react'

import './ServicePrice.scss'
import { URGENT_ALIADA_ID } from '@src/globals'

const ServicePrice = (props) => {
  const {
    aliada: {
      id,
      serviceCost,
      serviceOriginalCost
    },
    estimatedServiceHours,
    promoCode: {
      discountedPrice
    }
  } = props

  const isUrgentService = id == URGENT_ALIADA_ID

  const concept = `${estimatedServiceHours} horas`

  const price = discountedPrice || serviceCost
  const hasDecimal = price % 1 > 0
  const finalPrice = hasDecimal ? price.toFixed(2) : price

  function showOriginalPriceUp(){
    return serviceOriginalCost && !isUrgentService ? '$'+serviceOriginalCost : null
  }

  return (
    <div className='ServicePrice'>
      <p className='ServicePrice-originalPrice'
         style={{textDecorationLine:  'line-through',
                 textDecorationStyle: 'solid',
                 color:               'darkgray',
                 fontFamily:          '"Neuzeit Grotesk", "Helvetica Neue", Helvetica, Arial, sans-serif',
                 fontWeight:          'bold',
                 fontSize:            37}}>
        {showOriginalPriceUp()}
      </p>
      <p className='ServicePrice-price'>
        ${serviceOriginalCost && isUrgentService ? serviceOriginalCost : finalPrice}
      </p>
      <p className='ServicePrice-hours'>
        {estimatedServiceHours && concept}
      </p>
    </div>
  )
}

ServicePrice.displayName = 'ServicePrice'
ServicePrice.propTypes = {
  aliada: PropTypes.shape({
    serviceCost: PropTypes.number.isRequired
  }),
  estimatedServiceHours: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  promoCode: PropTypes.object
}
ServicePrice.defaultProps = {
  promoCode: {}
}

export default ServicePrice



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/ServicePrice/ServicePrice.js